import { firebaseDb, firebaseFuncs } from './firebase'
import { Collection, Functions, PaymentMethod } from '../config/enums'
import { installmentConverter } from '../models/Installment'

export const getInstallmentDetail = async (id: string) => {
  const doc = await firebaseDb
    .collection(Collection.installments)
    .doc(id)
    .withConverter(installmentConverter)
    .get()

  return doc.data()
}

export const payInstallment = async (
  installmentId: string,
  dueDate: Date,
  amount: number,
  paymentMethod: PaymentMethod
) => {
  const params = {
    installmentId,
    dueDate: dueDate.toDateString(),
    amount,
    paymentMethod
  }

  const payInstallmentFunc = firebaseFuncs.httpsCallable(
    Functions.payNextInstallment
  )
  await payInstallmentFunc(params)
}
